module.exports = __webpack_public_path__ + "static/img/gold.af0a5dd4.png";